/**
 * List of options for the Transfer types field
 *
 * @namespace tmrTransferTypes
 * @type {ngConstant}
 */
export const constant = [
  'tmrTransferTypes',
  {
    CREATION: 'TRANSFERTYPES.CREATION',
    OUTBOUND: 'TRANSFERTYPES.OUTBOUND',
    INBOUND: 'TRANSFERTYPES.INBOUND',
    TRANSFER_TO_ZONE: 'TRANSFERTYPES.TRANSFER_TO_ZONE',
    INVENTORY: 'TRANSFERTYPES.INVENTORY',
    UNKNOWN: 'TRANSFERTYPES.UNKNOWN',
  },
]

/**
 * Translates {@link tmrTransferTypes}
 *
 * @type {ngRun}
 */
let tmrTransferTypesRun = /*@ngInject*/ (TmrTranslate, tmrTransferTypes) =>
  TmrTranslate.object(tmrTransferTypes)

export { tmrTransferTypesRun as run }
